"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomAccessibility = void 0;
var RoomAccessibility;
(function (RoomAccessibility) {
    RoomAccessibility["Public"] = "public";
    RoomAccessibility["Private"] = "private";
})(RoomAccessibility || (exports.RoomAccessibility = RoomAccessibility = {}));
